export enum ComparisonOperatorEnum {
  EQUALS = 'equals',
}
